import { OpenLoanStatusEnum } from "../../utils/Helpers/OpenLoanStatusEnum";
import { ApplicationStatus } from "../Enums/ApplicationStatus";

export enum AccountSummaryPageKey {
  timeout = 'timeout',
  pendingApplicationSigning = 'pending-loan-agreement',
  pendingIvDocUpload = 'pending-document-upload',
  pendingIncomeAndBankVerification = 'pending-iv',
  pendingMandateAcceptance = 'pending-mandate-accept',
  disbursing = 'cashout',
  counterofferAvailable = 'pending-counter-offer',
}

export const getPage = (applicationStatus: ApplicationStatus): string => {
  switch (applicationStatus) {
    case ApplicationStatus.resume:
      return "/resume";
    case ApplicationStatus.processing:
      return "/processing";
    case ApplicationStatus.readyToSign:
      return "/apply-accept";
    case ApplicationStatus.pendingIv:
      return "/pending-iv";
    case ApplicationStatus.thanks:
      return "/accept";
    case ApplicationStatus.declined:
      return "/decline";
    case ApplicationStatus.counterOffer:
      return "/apply-counter-offer";
    case ApplicationStatus.processingCounterOffer:
      return "/processing-counter-offer";
    case ApplicationStatus.error:
      return "/error";
    case ApplicationStatus.invalidBankDetails:
      return "/invalidBankDetails";
    case ApplicationStatus.invalidIncome:
      return "/invalidIncome";
    case ApplicationStatus.timeout:
      return "/timeout";
    default:
      return applicationStatus.toString();
  }
};

export const appendMember = (track: string, isExistingCustomer: boolean, isConcurrentLoan: boolean): string => {
  if (isExistingCustomer && !isConcurrentLoan) {
    return track + "-member";
  }
  else if (isExistingCustomer && isConcurrentLoan) {
    return track + "-plus"
  }
  return track;
};

export const getPageKeyBasedOnOpenLoanStatus = (openLoanStatus: OpenLoanStatusEnum): string => {
  switch (openLoanStatus) {
    case OpenLoanStatusEnum.Unspecified:
      return AccountSummaryPageKey.timeout;
    case OpenLoanStatusEnum.PendingApplicationSigning:
      return AccountSummaryPageKey.pendingApplicationSigning;
    case OpenLoanStatusEnum.PendingIvDocUpload:
      return AccountSummaryPageKey.pendingIvDocUpload;
    case OpenLoanStatusEnum.PendingIncomeAndBankVerification:
      return AccountSummaryPageKey.pendingIncomeAndBankVerification;
    case OpenLoanStatusEnum.PendingMandateAcceptance:
      return AccountSummaryPageKey.pendingMandateAcceptance;
    case OpenLoanStatusEnum.Disbursing:
      return AccountSummaryPageKey.disbursing;
    case OpenLoanStatusEnum.CounterofferAvailable:
      return AccountSummaryPageKey.counterofferAvailable;
    default:
      return '';
  }
};
